import React, { Children, useState } from "react";

import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

// import JS files
import MuiTheme from "./MuiTheme";

// import Others files

const MuiSelect = ({
  size,
  inputLabel,
  labelId,
  id,
  label,
  menuItems,
  fromApi,
  onChange,
  value,
  defaultValue,
  haveAllOption,
  keyOnLoop=null,
}) => {
  return (
    <>
      <MuiTheme>
        <Box>
          <FormControl fullWidth size={size}>
            <InputLabel id={labelId}>{inputLabel}</InputLabel>
            <Select
              labelId={labelId}
              id={id}
              label={label}
              value={value}
              defaultValue={defaultValue}
              onChange={onChange}
            >
              {haveAllOption && <MenuItem value="all">همه</MenuItem>}

              {menuItems.map((item, index) => {
                return [
                  <MenuItem
                    value={fromApi ? item.id : item.value}
                  >
                    {item[keyOnLoop]}
                  </MenuItem>,
                ];
              })}
            </Select>
          </FormControl>
        </Box>
      </MuiTheme>
    </>
  );
};

export default MuiSelect;
